import { useState } from "react";
import "./FilterAndActions.scss";
import { BusIcon } from "../../styles/icons/svg";
import ActionButtonsBlock from "./ActionButtonsBlock";
import moment from "moment";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const FilterAndActions = (props) => {
  const [disableDate, setDisableDate] = useState(false);
  const { handleReminderDate, handelExpandAll, openSlider, serviceDueOnDt } = props;

  const handelExpandAllToggle = (event) => {
    handelExpandAll(event.target.checked);
  }

  const handleDisableDate = (val) => {
    setDisableDate(!disableDate);
    handleReminderDate(val);
  }

  return (
    <div className="filter-actions-wrapper">
      <div className="service-due-on-wrap">
        <div className="left-block">
          <span style={{ marginRight: "10px" }}>
            <BusIcon />
          </span>
          Services Due On :
        </div>
        <div className="right-block" onClick={openSlider} style={{ pointerEvents: disableDate === true ? 'none' : '' }}>
          <div className="date-wrap" style={{ border: disableDate === true ? "2px solid rgb(153, 153, 153)" : '', color: disableDate === true ? "rgb(153, 153, 153)" : '' }}>{serviceDueOnDt}</div>
          <span style={{ marginLeft: "10px", marginTop: "1px" }}>
            <CalendarTodayIcon style={{ color: disableDate === true ? 'rgb(153, 153, 153)' : '#1e59a7' }} />
          </span>
        </div>
      </div>
      <div className="option-expanded-view-wrap" style={{ background: "#ffffff" }}>
        <label className="label-checkbox-wrap">
          {`Reminder Schedule for Today ${moment(new Date()).format("ddd, DD-MMM-YY")}`}
          <input type="checkbox"
            onChange={() => handleDisableDate(2)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
      <div className="option-expanded-view-wrap">
        <label className="label-checkbox-wrap">
          Opt for Expanded View of All Services
          <input type="checkbox" onChange={handelExpandAllToggle} />
          <span className="checkmark"></span>
        </label>
      </div>
      <ActionButtonsBlock serviceDueOnDate={serviceDueOnDt} />
    </div>
  );
};

export default FilterAndActions;